import type { MaybeRef } from '@vueuse/core';
import { computed, unref, watch } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { useToast } from '@getaccept/lib-shared/src/toast';
import { useMyDocumentsToken } from './my-docments-token.composable';
import { useMyDocumentsUrl } from './my-documents-url.composable';

export const useMyDocumentsAuth = (userId: MaybeRef<string>, shouldLoad: MaybeRef<boolean>) => {
  const enabled = computed(() => !!unref(userId) && unref(shouldLoad));

  const { data: token, isError, isSuccess } = useMyDocumentsToken(userId, { enabled });
  const { toast } = useToast();

  const redirect = () => {
    const url = useMyDocumentsUrl().getMyDocumentsUrl(token.value);
    if (!url) {
      toast.danger(t('something-went-wrong'));
      return;
    }
    window.location.href = url;
  };

  watch(token, () => {
    if (token.value) {
      redirect();
    }
  });

  const isInvalidToken = computed(() => (isSuccess.value && !token.value) || isError.value);

  return { token, isInvalidToken, redirect };
};
